import { useInfluencerPermissions } from '@anytag/auth';
import { namedOperations, SocialAccountStatus, SocialAccountType } from '@anytag/graphql';
import { DefaultRefreshButton } from './default-refresh-button';
import { TwitterRefreshButton } from './twitter-refresh-button';
import { ThreadsRefreshButton } from './threads-refresh-button';

const supportedSocialMedias = [
  SocialAccountType.XHS,
  SocialAccountType.TIKTOK,
  SocialAccountType.TWITTER,
  SocialAccountType.THREADS,
  SocialAccountType.YOUTUBE,
  SocialAccountType.FACEBOOK,
  SocialAccountType.INSTAGRAM,
  SocialAccountType.FACEBOOK_PAGE
];

export interface RefreshInfluencerProfileButtonProps {
  className?: string;
  socialAccountId: number;
  status: SocialAccountStatus;
  socialMedia: SocialAccountType;
}
export const RefreshInfluencerProfileButton = ({
  status,
  className,
  socialMedia,
  socialAccountId
}: RefreshInfluencerProfileButtonProps) => {
  const { hideViewInfluencerProfile } = useInfluencerPermissions();

  if (hideViewInfluencerProfile || !supportedSocialMedias.includes(socialMedia)) {
    return null;
  }

  return socialMedia === SocialAccountType.TWITTER ? (
    <TwitterRefreshButton className={className} socialAccountId={socialAccountId} status={status} />
  ) : socialMedia === SocialAccountType.THREADS ? (
    <ThreadsRefreshButton
      className={className}
      socialMedia={socialMedia}
      socialAccountId={socialAccountId}
      refetchQueries={[namedOperations.Query.InfluencerProfileEstimatedAudience]}
    />
  ) : (
    <DefaultRefreshButton className={className} socialAccountId={socialAccountId} socialMedia={socialMedia} />
  );
};
